import {
  CmpTextField,
  CmpTextFieldEnter,
  CmpSelectBox,
} from "../../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
export default function WmsContent({
  sEnterKeyObj,
  vMediaQuery,
  xContent_Focus,
  xContent_Blur,
  xErrorMsgDetail,

  xBufferObj,
  sUnit,

  fUnit,
  fQty,
  fQty_Enter,
  fCardId,
  fCardIdEnter,
  fItemName,




}) {
  return (
    <form
      className="Wms-inbound-grn-content mt-4"
      id="WmsStockAdjustmentContent"
    >
      <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }}>
        <Grid item xs={4}>
          <CmpTextField
            xLabelText={"Sr.No"}
            xVariant={"standard"}
            xValue={xBufferObj.B_Srno}
            xType={"text"} // text/number/password
            xName={"B_Srno"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Srno === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Srno}
          />
        </Grid>
        <Grid item xs={8}>
          <CmpTextFieldEnter
            xLabelText={"Barcode"}
            xVariant={"standard"}

            xValue={xBufferObj.B_CardId}
            xType={"text"} // text/number/password
            xName={"B_CardId"}
            xReadOnly={false}
            xOnChange={fCardId}
            xError={xErrorMsgDetail.B_CardId === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_CardId}
            xtabIndex={"101"}
            xOnKeyUp={fCardIdEnter}
            xOnEnter={(e) => {
              fCardIdEnter(sEnterKeyObj);
            }}
            xSmShow={!!vMediaQuery}
          />
        </Grid>
        <Grid item xs={4}>
          <CmpTextField
            xLabelText={"Item Code"}
            xVariant={"standard"}
            xValue={xBufferObj.B_Itmcd}
            xType={"text"} // text/number/password
            xName={"B_Itmcd"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Itmcd === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Itmcd}
          />
        </Grid>
        <Grid item xs={8}>
          <CmpTextField
            xLabelText={"Item Name"}
            xVariant={"standard"}
            xValue={xBufferObj?.B_ItmName}
            xOnChange={fItemName}
            xReadOnly={true}
            xType={"text"}
            xName={"B_ItmName"}
            xError={xErrorMsgDetail.B_ItmName === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_ItmName}
            xtabIndex={"102"}
          />
        </Grid>

        <Grid item xs={4}>
          <CmpTextField
            xLabelText={"Qty"}
            xVariant={"standard"}
            xtabIndex={"104"}
            xValue={xBufferObj.B_Qty}
            xType={"number"} // text/number/password
            xName={"B_Qty"}
            xReadOnly={false}
            xOnChange={fQty}
            xError={xErrorMsgDetail.B_Qty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Qty}
            xOnKeyUp={fQty_Enter}
            xonFocus={(e) => {
              xContent_Focus(e);
            }}
            xonBlur={xContent_Blur}
          />
        </Grid>
        <Grid item xs={8}>
          <CmpSelectBox
            xtabIndex={"105"}
            xLabelText="Unit"
            xVariant={"standard"}
            xValue={xBufferObj.B_Unit}
            xOnChange={fUnit}
            xName={"unit"}
            xData={sUnit}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.B_Unit === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Unit}
            xDisable={false}
          />
        </Grid>
        <Grid item xs={4}>
          <CmpTextField
            xLabelText={"RefNo"}
            xVariant={"standard"}
            xtabIndex={"107"}
            xValue={xBufferObj.RefNo}
            xType={"text"} // text/number/password
            xName={"RefNo"}
            xReadOnly={true}
            xOnChange={""}
            xError={  false}
            xErrorMessage={""}
          />
        </Grid>
        {/* <Grid item xs={8}>
          <CmpTextField
            xLabelText={"Base Qty"}
            xVariant={"standard"}
            xtabIndex={"107"}
            xValue={xBufferObj.B_BaseQty}
            xType={"text"} // text/number/password
            xName={"B_BaseQty"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_BaseQty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_BaseQty}
          />
        </Grid> */}
      </Grid>
    </form>
  );
}
